

exports.__esModule = true;

var _squid = require('squid');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoEmailHeader', {
    tag: 'xo-email-header',
    template: _template2['default'],

    props: {
        flags: {
            type: 'var',
            required: true
        },
        user: {
            type: 'var',
            required: true
        },
        // This mode is carried from pages 'mode' setting
        // It is not flags.mode that changes upon radio button clicks
        // in optional signup flow
        mode: {
            type: 'var',
            required: true
        }
    },

    resolve: {
        experiments: function experiments() {
            return {
                showEmailCheckInfoBox: (0, _squid.$pxp)('xo_split_screen_header_email_change', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_split_screen_header_email_change_treatment_b')
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            var loginRedirectUrl = (0, _squid.$getRedirectUrl)('hermes', {
                hermesLoginRedirect: 'xoon'
            });

            // email check information message - variant 2 on split screen exp
            // exp name - xo_split_screen_header_email_change
            this.emailCheckInfo = {
                msgKeys: ['splitScreenExp.changeEmailInfo'],
                type: 'info'
            };

            /*
             * This key is valid in Country Change case
             * Country 1 config - Optional signup - UL found a account match in splitscreen
             *      In Country 1, user sees forced guest as UL found a matching account for
             *      user's account (As part of split screen account match)
             *  NOW USER CHANGE COUNTRY
             *
             *  Country 2 config - Forced signup - UL already found an account match in splitscreen
             *      In country 2, as we have already found a matching account for user entered
             *      email address in UL Split Screen flow, we want to show a specific warning message
             *      to user, as the email they entered in split screen first page, already has a
             *      member account
             */

            this.splitScreenFGAWarningMsg = {
                msgKeys: ['splitScreenExp.FGAWarningMsg'],
                type: 'warning',
                compileWith: {
                    href: loginRedirectUrl
                }
            };
        },
        populate: function populate() {
            var _this = this;

            var setSplitScreenPXPFlags = function setSplitScreenPXPFlags() {
                if (_this.experiments && _this.experiments.showEmailCheckInfoBox) {
                    // This enables diplay of a message to user right above email id
                    // about checking their email address before proceeding further
                    _this.showEmailCheckInfoBox = true;
                }
            };

            var setInitialFlags = function setInitialFlags() {
                if (_this.flags.showSplitScreenExp) {
                    setSplitScreenPXPFlags();
                }
            };

            setInitialFlags();
        }
    },

    actions: {
        redirectWarningPromptInit: function redirectWarningPromptInit($event) {
            if ($event) {
                $event.preventDefault();
            }

            // Redirection will be triggered in redirectWarningPrompt directive
            // based on few conditions check
            this.flags.showRedirectWarningPrompt = true;
        }
    }

});


_squid.$Component;

_squid.$locale;

_squid.$getRedirectUrl;

_squid.$pxp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/emailHeader/directive.js
// module id = ./components/xo-guest-components/src/guest/emailHeader/directive.js
// module chunks = 1